import React, { useEffect, useState } from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import styled from 'styled-components/macro';

import { getAllConfig } from 'configs';
import titles from 'configs/titles';
import { query } from 'utils';
import wechat from 'rpf/un/wechat';
import filterQuery from 'rpf/un/filterQuery';

import Loading from 'pages/Loading';
import Home from 'pages/Home';
import List from 'pages/List';
import Detail from 'pages/Detail';
import Card from 'pages/Card';

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

function App() {
  const [loaded, setLoaded] = useState(false);
  const [startLoad, setStartLoad] = useState(false);

  useEffect(() => {
    // 获取配置
    const {
      storeKey,
      opfStatisticSdkOpts,
      opfStatisticSdkApiUrl,
      shareParams,
      shortLink,
      serverTime,
      wechat: wcConfig
    } = getAllConfig();

    // 中行埋点初始化
    const opfStatisticSdk = window.opfStatisticSdk;
    async function initOpfStatisticSdk(userInfo) {
      const { openid, unionid } = userInfo;
      try {
        await opfStatisticSdk.init(
          {
            ...opfStatisticSdkOpts,
            openid,
            unionid,
            userInfo
          },
          opfStatisticSdkApiUrl
        );
      } catch (error) {
        console.log('opfStatisticSdk init error:', error);
        // await opfStatisticSdk.init(
        //   {
        //     ...opfStatisticSdkOpts,
        //     openid,
        //     unionid,
        //     userInfo
        //   },
        //   opfStatisticSdkApiUrl
        // );
      }
    }

    // 微信授权
    const $wechat = wechat({
      auth: wcConfig.auth,
      jsApi: wcConfig.jsApi
    });
    function userInfoAuth() {
      $wechat.goTwoAuth(
        'snsapi_userinfo',
        'STATE',
        filterQuery(window.location.href, ['code', 'info'], {
          info: 'ok'
        })
      );
    }
    function baseAuth() {
      $wechat.goTwoAuth(
        'snsapi_base',
        'STATE',
        filterQuery(window.location.href, ['code', 'info'], {
          base: 'ok'
        })
      );
    }
    async function wxAuth() {
      if (query.debug) {
        sessionStorage.setItem('openid', query.debug);
        setStartLoad(true);
      } else if (localStorage.getItem(storeKey)) {
        $wechat.config();
        const userInfo = JSON.parse(localStorage.getItem(storeKey));
        sessionStorage.setItem('openid', userInfo.openid);
        initOpfStatisticSdk(userInfo);
        setStartLoad(true);
      } else if (query.code) {
        if (query.info) {
          $wechat.config();
          $wechat
            .getUserInfo()
            .catch(err => {
              console.log('wechat getUserInfo', err);
              baseAuth();
            })
            .then(async userInfo => {
              userInfo &&
                localStorage.setItem(storeKey, JSON.stringify(userInfo));
              sessionStorage.setItem('openid', userInfo.openid);
              initOpfStatisticSdk(userInfo);
              setStartLoad(true);
            });
        } else {
          try {
            await $wechat.config();
            const openid = await $wechat.getOpenid();
            sessionStorage.setItem('openid', openid);
            initOpfStatisticSdk({ openid });
            userInfoAuth();
            setTimeout(() => setStartLoad(true), 100);
          } catch (err) {
            console.log('wechat getOpenid error:', err);
            baseAuth();
          }
        }
      } else {
        baseAuth();
      }
    }
    wxAuth();

    // 微信分享设置
    const wx = window.wx;
    const link = opfStatisticSdk.dealUrl(
      filterQuery(`${shortLink}${serverTime}${window.location.search}`, [
        'code',
        'debug'
      ])
    );
    wx.ready(() => {
      wx.onMenuShareAppMessage({
        ...shareParams,
        link,
        success: () => {
          opfStatisticSdk.share('friend');
        }
      });
      wx.onMenuShareTimeline({
        ...shareParams,
        link,
        success: () => {
          opfStatisticSdk.share('timeline');
        }
      });
    });
  }, []);

  // 根据路由设置 h5 标题
  const location = useLocation();
  useEffect(() => {
    document.title = titles[`${location.pathname}${location.search}`];
  }, [location]);

  const [appHeight, setAppHeight] = useState('100%');
  useEffect(() => {
    setAppHeight(window.innerHeight);
  }, []);

  return (
    <Wrap
      style={{
        height: appHeight
      }}
    >
      {!loaded ? (
        <Loading startLoad={startLoad} onFinish={() => setLoaded(true)} />
      ) : (
        <Switch>
          <Route exact path="/" component={Home}></Route>
          <Route path="/list" component={List}></Route>
          <Route path="/detail" component={Detail}></Route>
          <Route path="/card" component={Card}></Route>
        </Switch>
      )}
    </Wrap>
  );
}

export default App;
